/**
 * @fileoverview Main analysis wizard modal wrapper component
 */

import React from 'react';
import TrebbleModal from '../../common/TrebbleModal.tsx';
import AnalysisWizardContent from './AnalysisWizardContent.jsx';

/**
 * @typedef {import('../types/deepcut.js').AnalysisResults} AnalysisResults
 * @typedef {import('../types/deepcut.js').UserFeedback} UserFeedback
 */

/**
 * Main analysis wizard modal wrapper
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the modal is open
 * @param {AnalysisResults|null} props.results - Analysis results
 * @param {string} props.transcript - The transcript text
 * @param {number|null} props.transcriptId - ID of the transcript (if saved)
 * @param {Function} props.onClose - Callback for closing the wizard
 * @param {Function} props.onApply - Callback for applying the final plan
 * @param {boolean} [props.isUpdating] - Whether plan is being updated
 * @param {boolean} [props.isLoading] - Whether analysis is loading
 * @returns {React.ReactElement}
 */
export default function AnalysisWizard({
  open,
  results,
  transcript,
  transcriptId,
  onClose,
  onApply,
  isUpdating = false,
  isLoading = false
}) {
  return (
    <TrebbleModal
      title={null}
      open={open}
      onCancel={onClose}
      width={720}
      centered
      footer={null}
    >
      <AnalysisWizardContent
        results={results}
        transcript={transcript}
        transcriptId={transcriptId}
        onClose={onClose}
        onApply={onApply}
        isUpdating={isUpdating}
        isLoading={isLoading}
      />
    </TrebbleModal>
  );
} 